import React, { useRef, useState } from "react";
import { Dimmer } from "./spinner";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import axios from "axios";
import {
  seleccionarCampo,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  validaNumeroTelefono,
  validaEmail,
  diasMes,
  cmes,
} from "../util/varios";
import { Mensaje, MensajeSiNo } from "./mensajes";
import CatalogoAgenteTipo2 from "../catalogos/catalogoAgenteTipo2";

export const ResumenRetenciones = (props) => {
  const op = require("../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const token = JSON.parse(localStorage.getItem("token"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbAnio = useRef();
  const cmbMensual = useRef();
  const cmbStatus = useRef();
  const radioPeriodo = useRef();
  const radioAnual = useRef();
  const radioTodos = useRef();
  const radioUno = useRef();
  const txtAgente = useRef();

  const [teclas, setTeclas] = useState();
  const [catalogo, setCatalogo] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [anio, setAnio] = useState([]);
  const [visible, setVisible] = useState({
    periodo: "visible",
    anual: "visible",
  });

  const [agente, setAgente] = useState({
    idagente: "",
    nombre: "",
    rif: "",
    direccion: "",
  });

  const [visibleTodos, setVisibleTodos] = useState(false);

  const onChange = (event) => {
    if (event.target.name === "rango") {
      if (event.target.value === "1") {
        setVisible({
          ...visible,
          periodo: "visible",
          anual: "visible",
        });
      }

      if (event.target.value === "2") {
        setVisible({
          ...visible,
          periodo: "collapse",
          anual: "visible",
        });
      }
    }

    if (event.target.name === "todos") {
      if (event.target.value === "1") {
        setVisibleTodos(false);
        setAgente({
          idagente: "",
          nombre: "",
          rif: "",
          direccion: "",
        });
      }

      if (event.target.value === "2") {
        setVisibleTodos(true);
        setAgente({
          idagente: "",
          nombre: "",
          rif: "",
          direccion: "",
        });
      }
    }
  };

  const blanquear = () => {
    setActivate(false);
    setVisible({
      periodo: "visible",
      anual: "visible",
    });
    setVisibleTodos(false);
    setAgente({
      idagente: "",
      nombre: "",
      rif: "",
      direccion: "",
    });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const cerrarModal = () => {
    if (mensaje.titulo === "Exito.") {
      props.onHideRenderizar();
      props.onHideCancela();
      blanquear();
    }

    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const imprimirReporte = () => {
    let condicion = "";
    let titulo = "";
    let subtitulo = "";
    let sigue = false;
    let sta = cmbStatus.current.value;

    if (radioPeriodo.current.checked) {
      let peri = cmbMensual.current.value + "-" + cmbAnio.current.value;

      if (radioUno.current.checked && agente.idagente !== "") {
        titulo = `Resumen Por Periodo ${peri}`;
        subtitulo = "Por Agente";
        if (sta === "0") {
          condicion = `'where f.status isnull and r.montoretenido is not null and r.agenteretencion=${txtAgente.current.value} and r.periodo='||quote_literal('${peri}')`;
        } else if (sta === "2") {
          condicion = `'where f.status=2 and  r.agenteretencion=${txtAgente.current.value} and r.periodo='||quote_literal('${peri}')`;
        } else if (sta === "1") {
          condicion = `'where f.status=1 and  r.agenteretencion=${txtAgente.current.value} and r.periodo='||quote_literal('${peri}')`;
        } else if (sta === "cero") {
          condicion = `'where r.montoretenido isnull and r.agenteretencion=${txtAgente.current.value} and r.periodo='||quote_literal('${peri}')`;
        } else {
          condicion = `'where r.agenteretencion=${txtAgente.current.value} and r.periodo='||quote_literal('${peri}')`;
        }
        sigue = true;
      }
      if (radioTodos.current.checked) {
        titulo = `Resumen Por Periodo ${peri}`;
        subtitulo = "Todos Los Agentes 1x1000";
        if (sta === "0") {
          condicion = `'where f.status isnull and r.montoretenido is not null and r.periodo='||quote_literal('${peri}')`;
        } else if (sta === "2") {
          condicion = `'where f.status=2 and r.periodo='||quote_literal('${peri}')`;
        } else if (sta === "1") {
          condicion = `'where f.status=1 and r.periodo='||quote_literal('${peri}')`;
        } else if (sta === "cero") {
          condicion = `'where r.montoretenido isnull and r.periodo='||quote_literal('${peri}')`;
        } else {
          condicion = `'where r.periodo='||quote_literal('${peri}')`;
        }
        sigue = true;
      }
    }

    if (radioAnual.current.checked) {
      let anio = cmbAnio.current.value;
      if (radioUno.current.checked && agente.idagente !== "") {
        titulo = `Resumen Anual ${anio}`;
        subtitulo = "Por Agente";
        if (sta === "0") {
          condicion = `'where f.status isnull and r.montoretenido is not null and r.agenteretencion=${txtAgente.current.value} and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        } else if (sta === "2") {
          condicion = `'where f.status=2 and r.agenteretencion=${txtAgente.current.value} and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        } else if (sta === "1") {
          condicion = `'where f.status=1 and r.agenteretencion=${txtAgente.current.value} and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        } else if (sta === "cero") {
          condicion = `'where r.montoretenido isnull and r.agenteretencion=${txtAgente.current.value} and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        } else {
          condicion = `'where r.agenteretencion=${txtAgente.current.value} and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        }
        sigue = true;
      }

      if (radioTodos.current.checked) {
        titulo = `Resumen Anual ${anio}`;
        subtitulo = "Todos Los Agentes 1x1000";
        if (sta === "0") {
          condicion = `'where f.status isnull and r.montoretenido is not null and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        } else if (sta === "2") {
          condicion = `'where f.status=2 and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        } else if (sta === "1") {
          condicion = `'where f.status=1 and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        } else if (sta === "cero") {
          condicion = `'where r.montoretenido isnull and SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        } else {
          condicion = `'where SUBSTRING(r.periodo, 4, 4)='||quote_literal(${anio})`;
        }
        sigue = true;
      }
    }

    if (sigue) {
      window.open(
        `${op.reportes}reporte=Retenciones1x500Condi&CONDICION=${condicion}&TITULO=${titulo}&SUBTITULO=${subtitulo}&FECHASISTEMA=${fechaSistema}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };

  const onFecha = () => {
    var nanio = [];
    var aini = parseInt(anioActu) - 7;
    var afin = parseInt(anioActu);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "impuesto1x500";

    let endpoint = `${
      op.conexion
    }/api/retencion/seleccionaragente?&campos=${campos}&id=${idagente}&nomid=${nomid}&nomtab=${nomtab}&nomid2=${nomid2}&id2=${true}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtAgente.current.value = response.data.idagente;
            setAgente({
              idagente: response.data.idagente,
              nombre: response.data.nombre,
              rif: response.data.rif,
              direccion: response.data.direccion,
            });
          } else {
            setAgente({
              idagente: "",
              nombre: "",
              rif: "",
              direccion: "",
            });
            if (teclas === 13) {
              setTimeout(() => {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "Código/Agente no Existe...",
                  icono: "error",
                });
                txtAgente.current.value = "";
                txtAgente.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarAgente = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTeclas(event.which);
        datosAgente(event.target.value);
      } else {
        txtAgente.current.value = "";
      }
    }
  };

  const aceptarCatalogo = (idage, nombage, rif, direccion, status) => {
    txtAgente.current.value = idage;
    setAgente({
      idagente: idage,
      nombre: nombage,
      rif: rif,
      direccion: direccion,
    });
  };

  const handleCatalogo = () => {
    setCatalogo(true);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        onFecha();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          Resumen Retenciones 1x1000
        </Modal.Title>
        <button
          ref={btnCancela}
          style={{
            border: 0,
            margin: 0,
            padding: 0,
            color: "#ffffff",
            backgroundColor: "transparent",
          }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <div>
          <div
            style={{ fontFamily: "Times New Roman, Times, serif" }}
            className="row col-md-12 justify-content-between"
          >
            <fieldset className=" row col-sm-12 mx-auto border rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px", fontWeight: "bold" }}
              >
                Resumen por:
              </legend>

              <div className="row col-md-6">
                <div className="col-md-4 d-flex">
                  <input
                    ref={radioPeriodo}
                    style={{
                      width: "1.25rem",
                      height: "1.25rem",
                      outline: "none",
                    }}
                    onChange={onChange}
                    value="1"
                    defaultChecked={true}
                    type="radio"
                    id="rango"
                    name="rango"
                  />
                  <label
                    className="form-check-label  px-1"
                    htmlFor="exonintereses"
                  >
                    Periodo
                  </label>
                </div>
                <div className="col-md-4 d-flex">
                  <input
                    ref={radioAnual}
                    style={{
                      width: "1.25rem",
                      height: "1.25rem",
                      outline: "none",
                    }}
                    onChange={onChange}
                    value="2"
                    type="radio"
                    id="rango"
                    name="rango"
                  />
                  <label className="form-check-label px-1" htmlFor="exonmultas">
                    Anual
                  </label>
                </div>
              </div>

              <div className="row col-md-6 justify-content-between">
                {visible.periodo === "visible" && (
                  <select
                    ref={cmbMensual}
                    className="form-select form-select-sm col-md-6"
                  >
                    <option key="01" value="01">
                      ENERO
                    </option>
                    <option key="02" value="02">
                      FEBRERO
                    </option>
                    <option key="03" value="03">
                      MARZO
                    </option>
                    <option key="04" value="04">
                      ABRIL
                    </option>
                    <option key="05" value="05">
                      MAYO
                    </option>
                    <option key="06" value="06">
                      JUNIO
                    </option>
                    <option key="07" value="07">
                      JULIO
                    </option>
                    <option key="08" value="08">
                      AGOSTO
                    </option>
                    <option key="09" value="09">
                      SEPTIEMBRE
                    </option>
                    <option key="10" value="10">
                      OCTUBRE
                    </option>
                    <option key="11" value="11">
                      NOVIEMBRE
                    </option>
                    <option key="12" value="12">
                      DICIEMBRE
                    </option>
                  </select>
                )}

                {visible.anual === "visible" && (
                  <select
                    name="anio"
                    ref={cmbAnio}
                    onChange={onChange}
                    className="form-select form-select-sm col-md-4"
                  >
                    {anio &&
                      anio.map((a) => (
                        <option key={a.anio} value={a.anio}>
                          {a.anio}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            </fieldset>
            <fieldset className=" row col-md-6 mx-auto border rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px", fontWeight: "bold" }}
              >
                Agente 1x1000:
              </legend>

              <div className="row col-md-12">
                <div className="col-md-6 d-flex">
                  <input
                    ref={radioTodos}
                    style={{
                      width: "1.25rem",
                      height: "1.25rem",
                      outline: "none",
                    }}
                    onChange={onChange}
                    value="1"
                    defaultChecked={true}
                    type="radio"
                    id="todos"
                    name="todos"
                  />
                  <label
                    className="form-check-label  px-1"
                    htmlFor="exonintereses"
                  >
                    Todos
                  </label>
                </div>
                <div className="col-md-6 d-flex">
                  <input
                    ref={radioUno}
                    style={{
                      width: "1.25rem",
                      height: "1.25rem",
                      outline: "none",
                    }}
                    onChange={onChange}
                    value="2"
                    type="radio"
                    id="todos"
                    name="todos"
                  />
                  <label className="form-check-label px-1" htmlFor="exonmultas">
                    Por Agente
                  </label>
                </div>
              </div>
            </fieldset>

            <fieldset className=" row col-md-5 mx-auto border rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px", fontWeight: "bold" }}
              >
                Estatus Pago:
              </legend>
              <select
                ref={cmbStatus}
                className="form-select form-select-sm col-md-12"
                style={{ color: "red", fontWeight: "bold" }}
              >
                <option key="01" value="">
                  Todos
                </option>
                <option key="02" value="0">
                  Por Pagar
                </option>
                <option key="03" value="2">
                  Verificando Pago
                </option>
                <option key="04" value="1">
                  Pagada
                </option>
                <option key="05" value="cero">
                  En Cero
                </option>
              </select>
            </fieldset>

            {visibleTodos && (
              <fieldset className=" row col-sm-12 mx-auto border rounded">
                <legend
                  className="float-none w-auto"
                  style={{ fontSize: "15px", fontWeight: "bold" }}
                >
                  Datos del Agente 1x1000:
                </legend>
                <div className="input-group input-group-sm col-md-3">
                  <label
                    htmlFor="idagente"
                    className="form-label input-group-text"
                    id="validationTooltipAgente"
                    style={{ backgroundColor: "#55acee" }}
                  >
                    Código:
                  </label>
                  <input
                    type="text"
                    ref={txtAgente}
                    name="idagente"
                    autoComplete="off"
                    aria-describedby="validationTooltipAgente"
                    onFocus={seleccionarCampo}
                    placeholder="Código"
                    className="form-control border"
                    onKeyUp={validarAgente}
                    onChange={onChange}
                    required
                  />
                  <button className="btn btn-info" onClick={handleCatalogo}>
                    <i className="fa fa-search"></i>
                  </button>
                </div>
                <label className="form-check-label px-1 py-1">
                  NOMBRE: {agente.nombre}
                </label>
                <label className="form-check-label px-1">
                  RIF: {agente.rif}
                </label>
                <label className="form-check-label px-1">
                  DIRECCIÓN: {agente.direccion}
                </label>
              </fieldset>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={imprimirReporte}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Mensaje mensaje={mensaje} onHide={cerrarModal} />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
      <CatalogoAgenteTipo2
        show={catalogo}
        campoclave="impuesto1x500"
        valorclave="true"
        onHideCancelaCatAge={() => setCatalogo(false)}
        onHideAceptaCatAge={aceptarCatalogo}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modalResumenRetenciones.js